import { render, staticRenderFns } from "./ChooseAddressFieldset.vue?vue&type=template&id=05c36718"
import script from "./ChooseAddressFieldset.vue?vue&type=script&lang=ts"
export * from "./ChooseAddressFieldset.vue?vue&type=script&lang=ts"
import style0 from "./ChooseAddressFieldset.scss?vue&type=style&index=0&prod&lang=scss&module=true&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports